module.exports = __webpack_public_path__ + "static/media/Laravel.479bdcf1.jpg";